import CustomLink from 'src/components/atoms/CustomLink';
import { CustomLinkType } from 'src/components/atoms/CustomLink/customLink.types';
import LanguageSpan from 'src/components/atoms/LanguageSpan';
import Tooltip from 'src/components/atoms/Tooltip';
import { clearSpan } from 'src/services/languageSpanHelpers';
import { useLabels, useLanguageStore } from 'src/StoreDataProvider';
import { ProjectDataProps } from './projectData.types';

const ProjectData: (props: ProjectDataProps) => JSX.Element = ({
  projectName,
  country,
  sector,
  sector2,
  carrierType,
  year,
  investment,
  sourceOfFounds,
  projectNumber,
  reportUrl,
}) => {
  const labels = useLabels();
  const lang = useLanguageStore();
  const browserLang = lang.language === 'EN' ? 'en-US' : 'de-DE';

  return (
    <div className="project-data">
      <h2 data-cy="project-data-heading">{labels.projectData}</h2>
      <h3 data-cy="project-data-title-heading">{labels.projectTitle}</h3>
      <p data-cy="project-data-title-text">
        <LanguageSpan
          text={projectName}
          keyPrefix={'project-data-title-text'}
        ></LanguageSpan>
      </p>
      <h3 data-cy="project-data-country-heading">{labels.country}</h3>
      <p data-cy="project-data-country-text">
        <LanguageSpan
          text={country}
          keyPrefix={'project-data-country-text'}
        ></LanguageSpan>
      </p>
      <h3 data-cy="project-data-sector-heading">{labels.sector}</h3>
      <p data-cy="project-data-sector-text">
        <LanguageSpan
          text={sector}
          keyPrefix={'project-data-sector-text'}
        ></LanguageSpan>
      </p>
      <h3 data-cy="project-data-sector2-heading">{labels.sector2}</h3>
      <p data-cy="project-data-sector2-text">
        <LanguageSpan
          text={sector2}
          keyPrefix={'project-data-sector2-text'}
        ></LanguageSpan>
      </p>
      <h3 data-cy="project-data-type-of-project-partner-heading">
        {labels.typeOfProjectPartner}
      </h3>
      <p data-cy="project-data-type-of-project-partner">
        <LanguageSpan
          text={carrierType}
          keyPrefix={'project-data-type-of-project-partner'}
        ></LanguageSpan>
      </p>
      <h3 data-cy="project-data-year-heading">{labels.year}</h3>
      <p data-cy="project-data-year-text">{year}</p>
      <div className="totalFunds">
        <h3 data-cy="project-data-total-funds-heading">{labels.totalFunds}</h3>
        <Tooltip
          tooltipText={labels.tooltipTotalFunds}
          aria-label={labels.tooltipTotalFunds}
        />
      </div>
      <p data-cy="project-data-total-funds-text">
        {investment
          ? Number(investment).toLocaleString(browserLang, {
              style: 'currency',
              currency: 'EUR',
              maximumFractionDigits: 0,
            })
          : '-'}
      </p>
      <h3 data-cy="project-data-source-of-funds-heading">
        {labels.sourceOfFounds}
      </h3>
      <p data-cy="project-data-source-of-funds-text">
        <LanguageSpan
          text={sourceOfFounds}
          keyPrefix={'project-data-source-of-funds-text'}
        ></LanguageSpan>
      </p>
      <h3 data-cy="project-data-project-number-heading">
        {labels.projectNumber}
      </h3>
      <p data-cy="project-data-project-number-text">{projectNumber}</p>
      <CustomLink
        label={labels.showReport}
        type={CustomLinkType.nav_outline}
        icon={'icon-pfeil-rechts'}
        href={reportUrl}
        disabled={!reportUrl}
        ariaLabel={`${labels.downloadReportInfo1} '${clearSpan(projectName)}'${
          labels.downloadReportInfo2
        }`}
        target="_blank"
      />
    </div>
  );
};

export default ProjectData;
